<template>
  <div>
    <el-table :data="pageMaterialList" class="m-t-10" border max-height="600">
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed="left"
      />
      <el-table-column label="品目信息" align="center" fixed="left" width="300">
        <el-table-column
          v-for="item in materielInfoConfig"
          :key="item.defineCode"
          class="info-item"
          :label="item.columnName"
          align="center"
          fixed="left"
          width="100"
        >
          <template v-slot:default="{ row }">
            <span>{{ row[item.defineCode] || '-' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="采购量/计量单位" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>
            {{ row[numConfig.defineCode] }} /
            {{ row[unitConfig.defineCode] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="modelConfig.isEnable"
        :label="modelConfig.columnName"
        :prop="modelConfig.defineCode"
        min-width="100"
        align="center"
      >
        <template v-slot:default="{ row }">
          <span>{{ row[modelConfig.defineCode] || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="controlPriceConfig.isEnable"
        :label="
          `${controlPriceConfig.columnName.replace('（元）', '')}(${
            isDollar ? '美元' : '元'
          })`
        "
        :prop="controlPriceConfig.defineCode"
        min-width="100"
        align="center"
      >
        <template v-slot="{ row }">
          <span>
            {{ row.controlPrice ? strToThousands(row.controlPrice) : ' - ' }}
          </span>
          <div v-if="!isDollar">
            <money-in-cn :money="row.controlPrice" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="采购人指定" align="center">
        <el-table-column
          v-for="item in purchaseSpecifyConfig"
          :key="item.defineCode"
          :label="item.columnName"
          align="center"
        >
          <template v-slot:default="{ row }">
            <span>{{ row[item.defineCode] || '-' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        v-if="hasTargetPrice"
        label="目标不含税单价"
        header-align="center"
        min-width="100"
        show-overflow-tooltip
        align="center"
      >
        <template slot="header">
          <span>目标不含税单价({{ isDollar ? '美元' : '元' }})</span>
          <el-tooltip
            class="m-l-8"
            effect="dark"
            content="目标不含税单价作为采购人心理预期价，仅供参考"
            placement="top"
          >
            <i class="el-icon-info "></i>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">
          <span>
            {{ row.targetPrice ? strToThousands(row.targetPrice) : ' - ' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="对供应商备注" align="center" min-width="160px">
        <template slot-scope="{ row }">
          <span>
            {{ row.remarks || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" min-width="160px">
        <template slot-scope="{ row }">
          <upload
            v-if="row.attachmentFileIds && row.attachmentFileIds[0]"
            :props-data="{
              disabled: true,
              uploadMode: 'fileId',
              fileIdBefore: row.attachmentFileIds[0]
            }"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="报价详情" align="center">
        <el-table-column
          v-for="item in supplierResponseConfig"
          :key="item.defineCode"
          :label="item.columnName"
          align="center"
          width="200"
        >
          <template v-slot:header>
            <span
              class="info-item-label"
              :class="{
                require:
                  item.supplierRequire ===
                  materialTemplateKeySupplierRequireDict.YES.value
              }"
            >
              {{ item.columnName || '-' }}
            </span>
          </template>
          <template v-slot:default="{ row, $index }">
            <span
              v-if="item.defineCode === 'offerMaterielBrand'"
              class="info-item-value"
            >
              <span v-if="hsPurchaseBrand">
                {{ row.offerMaterielBrand }}
              </span>
              <template v-else>
                <el-input
                  v-if="!disabled && !quoteFormDisabled"
                  v-model.trim="row[item.defineCode]"
                  placeholder="请输入"
                  maxlength="200"
                />
                <span v-else>{{ row[item.defineCode] || '-' }}</span>
              </template>
            </span>
            <span
              v-else-if="item.defineCode === 'offerPrice'"
              class="info-item-value"
            >
              <!-- 五菱要求优先填写非含税价 -->
              <span v-if="requireTax">{{ taxPrice(row) }}</span>
              <div v-else class="flex row-center">
                <el-input
                  v-if="!disabled && !quoteFormDisabled"
                  v-model="row.offerPrice"
                  :class="{ 'is-error': priceIsError[$index] }"
                  size="small"
                  placeholder="请输入报价金额"
                  @change="changeOfferPrice(row, $index)"
                  @blur="handleOfferPriceBlur(row, 'offerPrice', $index)"
                />
                <span v-else>{{ row.offerPrice || '-' }}</span>
              </div>
              <div
                v-if="priceIsError[$index]"
                style="color: #ff2626; text-align: left; font-size: 12px"
              >
                高于上一轮报价
              </div>
            </span>
            <span
              v-else-if="item.defineCode === 'offerTaxRate'"
              class="info-item-value"
            >
              <el-input
                v-if="!disabled && !quoteFormDisabled"
                v-model="row.offerTaxRate"
                size="small"
                placeholder="请输入税率"
                @change="handleTaxRateChange(row)"
                @blur="formatNumberInput(row, 'offerTaxRate', $index)"
              />
              <span v-else>{{ row.offerTaxRate || '-' }}</span>
            </span>
            <span
              v-else-if="item.defineCode === 'noRateOfferPrice'"
              class="info-item-value"
            >
              <div class="flex row-center">
                <el-input
                  v-if="!disabled && !quoteFormDisabled"
                  v-model="row.noRateOfferPrice"
                  :class="{ 'is-error': priceIsError[$index] }"
                  size="small"
                  placeholder="请输入报价金额"
                  @change="validOfferPrice(row, $index)"
                  @blur="handleOfferPriceBlur(row, 'noRateOfferPrice', $index)"
                />
                <span v-else>{{ row.noRateOfferPrice || '-' }}</span>
              </div>
              <div
                v-if="priceIsError[$index]"
                style="color: #ff2626; text-align: left; font-size: 12px"
              >
                高于上一轮报价
              </div>
            </span>
            <span
              v-else-if="
                item.defineCode === 'offerTotalPrice' ||
                  item.defineCode === 'noRateTotalPrice'
              "
              class="info-item-value"
            >
              <span>
                {{
                  (requireTax ? row.noRateTotalPrice : row.offerTotalPrice) || 0
                }}
              </span>

              <div v-if="!isDollar">
                <money-in-cn
                  :money="
                    requireTax ? row.noRateTotalPrice : row.offerTotalPrice
                  "
                  :show-prefix="false"
                />
              </div>
            </span>
            <span
              v-else-if="item.defineCode === 'offerRemark'"
              class="info-item-value"
            >
              <el-input
                v-if="!disabled && !quoteFormDisabled"
                v-model.trim="row.offerRemark"
                placeholder="请输入"
                type="textarea"
                :rows="2"
                maxlength="500"
              />
              <span v-else>{{ row.offerRemark || '-' }}</span>
            </span>
            <span
              v-else-if="item.defineCode === 'offerDeliveryDay'"
              class="info-item-value"
            >
              <el-input-number
                v-if="!disabled && !quoteFormDisabled"
                v-model.trim="row.offerDeliveryDay"
                placeholder="请输入"
                :min="0"
                :precision="0"
              />
              <span v-else>{{ row.offerDeliveryDay }}</span>
            </span>
            <span v-else class="info-item-value">
              <el-input
                v-if="!disabled && !quoteFormDisabled"
                v-model.trim="row[item.defineCode]"
                placeholder="请输入"
                maxlength="200"
              />
              <span v-else>{{ row[item.defineCode] || '-' }}</span>
            </span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <!--前端模拟分页-->
    <jczh-pagination
      v-show="form.table.length > size"
      :total="form.table.length"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>

<script>
import Upload from '@/components/common/Upload/index.vue'
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'
import { cloneDeep, isEqual, round } from 'lodash'
import { strToThousands } from '@/utils/utils'
import MoneyInCn from '@/components/common/MoneyInCn.vue'
import {
  materialColumnTypeDict,
  materialTemplateDefineTypeDict,
  materialTemplateKeySupplierRequireDict,
  materialTemplateKeySupplierVisibleDict
} from '@/dictionary/material/template'

/**
 * @description 五菱发布的项目，供应商报价组件
 */
export default {
  name: 'PurchaseListSupplierOfferWuling',

  components: { MoneyInCn, Upload },

  mixins: [materialColumnMixin],

  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 操作模式
    operation: {
      type: String,
      default: 'detail'
    },

    // 报价单是否可编辑
    quoteFormDisabled: {
      type: Boolean,
      default: false
    },

    // 是否是在供应商视角
    isSupplier: {
      type: Boolean,
      default: false
    },

    // 当前报价轮次信息
    currentRound: {
      type: Object,
      default: () => {}
    },

    // 报价是否含税
    requireTax: {
      type: Boolean,
      default: false
    },

    // 是否隐藏税率
    hideTaxRate: {
      type: Boolean,
      default: false
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      materialTemplateKeySupplierRequireDict,

      form: {
        // 表格数据
        table: []
      },

      // 前端模拟分页变量
      pageMaterialList: [],
      page: 1,
      size: 20,

      // 保存表格中表单的校验错误的结果
      priceIsError: []
    }
  },

  computed: {
    // 是否指定了目标价
    hasTargetPrice() {
      return this.form.table.some(item => item.targetPrice)
    },

    // 是否可编辑
    disabled() {
      return this.operation === 'detail'
    },

    // 品牌/制造商的表头配置
    offerBrandConfig() {
      return this.itemSchemaList.find(
        config => config.defineCode === 'offerMaterielBrand'
      )
    },

    // 采购人是否指定了品牌/制造商
    hsPurchaseBrand() {
      return this.form.table.some(item => item.materielBrand)
    }
  },

  watch: {
    tableData: {
      handler(val) {
        if (val?.length > 0 && !isEqual(val, this.form.table)) {
          this.form.table = cloneDeep(val)
          this.form.table.forEach(item => {
            if (this.requireTax) {
              item.offerPrice = this.taxPrice(item)
            }
            if (this.hsPurchaseBrand) {
              // 如果采购人指定了品牌/制造商，则供应商不可修改
              item.offerMaterielBrand = item.materielBrand
            }
          })
          this.getPageData()
        }
      },
      deep: true,
      immediate: true
    },

    itemSchemaList: {
      handler(val) {
        if (val?.length > 0) {
          this.columnConfig = cloneDeep(val)
          this.setSupplierOfferConfig(
            this.requireTax,
            this.isSupplier,
            this.hideTaxRate,
            this.isDollar,
            true
          )
        }
      },
      deep: true,
      immediate: true
    },

    isDollar: {
      handler: function(val) {
        this.setSupplierOfferConfig(
          this.requireTax,
          this.isSupplier,
          this.hideTaxRate,
          this.isDollar,
          true
        )
      },
      immediate: true
    },

    size(val) {
      this.getPageData()
    },

    page(val) {
      this.getPageData()
    },

    'form.table': {
      handler(val) {
        if (val?.length) {
          this.updateTableData()
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    strToThousands,

    /**
     * 单个品目的含税总价
     */
    offerTotalPrice(row) {
      // 非含税报价项目，offerPrice为报价
      // 含税报价项目，noRateOfferPrice为报价
      const offerPrice = this.requireTax ? row.noRateOfferPrice : row.offerPrice
      if (!offerPrice || isNaN(offerPrice)) return ''

      const num = Number(row[this.numConfig.defineCode] || 0) * 100
      const price = Number(offerPrice || 0) * 100
      const rate = 100 + Number(row.offerTaxRate || 0)
      const result = (num * price * rate) / 1000000
      return isNaN(result) ? '' : round(result, 2).toFixed(2)
    },

    noRateTotalPrice(row) {
      const offerPrice = row.noRateOfferPrice
      if (!offerPrice || isNaN(offerPrice)) return ''
      const num = Number(row[this.numConfig.defineCode] || 0) * 100
      const price = Number(offerPrice || 0) * 100
      const result = (num * price) / 10000
      return isNaN(result) ? '' : round(result, 2).toFixed(2)
    },

    /**
     * 前端模拟分页
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.form.table.slice(start, end)
    },

    /**
     * 计算含税价
     * @param row
     */
    taxPrice(row) {
      if (!this.requireTax) {
        // 报价不含税则直接返回offerPrice
        return row.offerPrice
      }
      const rate = Number(row.offerTaxRate || 0) + 100
      const price = Number(row.noRateOfferPrice || 0) * 100
      const result = (price * rate) / 10000
      return isNaN(result) ? '' : round(result, 2).toFixed(2)
    },

    // 计算未含税价
    withoutTaxPrice(row) {
      if (row.offerPrice && row.offerTaxRate) {
        const result = (
          Number(row.offerPrice || 0) /
          ((100 + Number(row.offerTaxRate || 0)) / 100)
        ).toFixed(2)
        return isNaN(parseFloat(result)) ? '' : result
      } else {
        return ''
      }
    },

    /**
     * 税率或报价变化
     */
    handleTaxRateChange(row) {
      this.$set(row, 'offerPrice', this.taxPrice(row))
      this.$set(row, 'offerTotalPrice', this.offerTotalPrice(row))
      this.$set(row, 'noRateTotalPrice', this.noRateTotalPrice(row))
      this.updateTableData()
    },

    handleOfferPriceBlur(row, propName, index) {
      this.formatNumberInput(row, propName, index)
      this.updateTableData()
    },

    /**
     * 校验输入的价格，格式是否正确
     */
    formatNumberInput(row, propName, index) {
      let temp = row[propName]?.toString() || '' // 第一步，转成字符串
      temp = temp.replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
      temp = temp.replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
      temp = temp.replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
      temp = temp.match(/^\d*(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      row[propName] = temp
    },

    /**
     * 根据当前轮次中的needLowOffer判断是否需要比前一次报价低
     */
    validOfferPrice(row, index) {
      this.handleTaxRateChange(row)

      // const tempErrorArray = cloneDeep(this.priceIsError)
      // // 根据当前轮次中的needLowOffer判断是否需要比前一次报价低
      // if (
      //   this.currentRound?.needLowOffer &&
      //   this.previousRoundQuote[index].offerPrice &&
      //   Number(row.offerPrice) >
      //     Number(this.previousRoundQuote[index].offerPrice)
      // ) {
      //   tempErrorArray[index] = true
      // } else {
      //   tempErrorArray[index] = false
      // }
      // this.priceIsError = tempErrorArray
    },

    changeOfferPrice(row, index) {
      this.$set(row, 'offerTotalPrice', this.offerTotalPrice(row))
      this.updateTableData()
    },

    /**
     * 将修改后的表格数据传出
     */
    updateTableData() {
      this.$emit('updateTable', cloneDeep(this.form.table))
    },

    /**
     * 设定用于供应商端报价表的相应信息模板
     * @param {Boolean} requireTax 是否含税
     * @param {Boolean} isSupplier 供应商视角
     * @param {Boolean} hideTaxRate 是否隐藏税率信息
     */
    setSupplierOfferConfig(
      requireTax = false,
      isSupplier = false,
      hideTaxRate = false,
      isDollar = false
    ) {
      this.materielInfoConfig = []
      this.purchaseSpecifyConfig = []
      this.supplierResponseConfig = []
      // 供应商端的供应商响应列需要添加报价相关的字段
      this.supplierResponseConfig = [
        requireTax && !hideTaxRate
          ? {
            columnName: `未含税价（${isDollar ? '美元' : '元'}）`,
            defineType: materialTemplateDefineTypeDict.RESPONSE.value,
            defineCode: 'noRateOfferPrice',
            supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
            supplierVisible: null,
            columnType: materialColumnTypeDict.CUSTOM.value
          }
          : {
            columnName: `未含税价（${isDollar ? '美元' : '元'}）`,
            defineType: materialTemplateDefineTypeDict.RESPONSE.value,
            defineCode: 'offerPrice',
            supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
            supplierVisible: null,
            columnType: materialColumnTypeDict.CUSTOM.value
          },
        requireTax && !hideTaxRate
          ? {
            columnName: '税率（%）',
            defineType: materialTemplateDefineTypeDict.RESPONSE.value,
            defineCode: 'offerTaxRate',
            supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
            supplierVisible: null,
            columnType: materialColumnTypeDict.CUSTOM.value
          }
          : undefined,
        requireTax
          ? {
            columnName: `含税价（${isDollar ? '美元' : '元'}）`,
            defineType: materialTemplateDefineTypeDict.RESPONSE.value,
            defineCode: 'offerPrice',
            supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
            supplierVisible: null,
            columnType: materialColumnTypeDict.CUSTOM.value
          }
          : null,
        {
          columnName: `报价总金额（${isDollar ? '美元' : '元'}）`,
          defineType: materialTemplateDefineTypeDict.RESPONSE.value,
          defineCode: this.requireTax ? 'noRateTotalPrice' : 'offerTotalPrice',
          supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
          supplierVisible: null,
          columnType: materialColumnTypeDict.CUSTOM.value
        }
      ].filter(value => value)

      // 如果采购人指定了品牌，则供应商报价不展示品牌
      // 如果采购人未指定品牌，则供应商报价要展示品牌且是必填
      // const row = this.form.table[0]
      // if (!row.materielBrand) {
      //   this.supplierResponseConfig.push({
      //     columnName: '品牌/制造商',
      //     defineType: materialTemplateDefineTypeDict.RESPONSE.value,
      //     defineCode: 'offerMaterielBrand',
      //     supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
      //     supplierVisible: null,
      //     columnType: materialColumnTypeDict.CUSTOM.value
      //   })
      // }

      this.columnConfig.forEach(item => {
        // 获取品目名称和品目编码的字段配置
        if (
          item.columnType === materialColumnTypeDict.NAME.value ||
          item.columnType === materialColumnTypeDict.CODE.value
        ) {
          this.materielInfoConfig.push(item)
        }
        // 获取供应商响应且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
          item.isEnable
        ) {
          this.supplierResponseConfig.push(item)
        }
        // 获取采购人指定且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
          item.isEnable
        ) {
          // 在供应商视角需要隐藏对供应商不可见的采购人指定
          if (isSupplier) {
            if (
              item.supplierVisible ===
              materialTemplateKeySupplierVisibleDict.YES.value
            ) {
              this.purchaseSpecifyConfig.push(item)
            }
          } else {
            this.purchaseSpecifyConfig.push(item)
          }
        }
      })

      // 由于模板中不存在分类的定义，需要手动添加分类
      this.materielInfoConfig.push({
        defineCode: 'categoryId',
        columnName: '分类'
      })

      // 最后供应商响应中还需加入备注
      this.supplierResponseConfig.push({
        columnName: '备注',
        defineType: materialTemplateDefineTypeDict.RESPONSE.value,
        defineCode: 'offerRemark',
        supplierRequire: materialTemplateKeySupplierRequireDict.NO.value,
        supplierVisible: null,
        columnType: materialColumnTypeDict.CUSTOM.value
      })

      // 后端的交货周期不是必填项，前端添加校验和限制
      this.supplierResponseConfig.forEach(config => {
        if (config.defineCode === 'offerDeliveryDay') {
          config.supplierRequire =
            materialTemplateKeySupplierRequireDict.YES.value
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table {
  .el-table__fixed {
    width: 360px;
  }
}

.info-item-label {
  display: inline-block;

  &.require {
    &::before {
      content: '*';
      color: $danger-color;
    }
  }
}
</style>
